import { render } from "./GroupsManager.vue?vue&type=template&id=45e27b11"
import script from "./GroupsManager.vue?vue&type=script&lang=js"
export * from "./GroupsManager.vue?vue&type=script&lang=js"

import "./GroupsManager.vue?vue&type=style&index=0&id=45e27b11&lang=css"

import exportComponent from "/home/debian/plan.docks40.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__